export default __webpack_public_path__ + "static/img-point-fourth-b323f4a48b4d01a0804e9d46adc8fb40.avif";